/**
 * General scripts
 * 
 * This file should contain any scripts needed. Instead of calling it in the header 
 * or throwing it inside wp_head(), this file will be called automatically in the 
 * footer for better performance.
 *
 * @package   seedyjoints
 * @since     JointsWP
 * @author    <corey@chatmandesign.com>
 * @link      http://chatmandesign.com
 */

//! – GLOBAL VARIABLES

var responsive_viewport = null;

(function($) {
	//! – WHILE LOADING

	loadYouTubePlayerAPI();
	fullBleedVideo();
	fullBleedPromo();
	
	//! – DOM READY
	
	$(function() {

		//! –– POLYFILLS & FALLBACKS
		
		/**
		 * Makes "skip to content" link work correctly in Chrome (and IE9) for better
		 * accessibility. From Twenty Fourteen.
		 *
		 * @link http://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
		 */
		$(window).on( 'hashchange', function() {
			var element = document.getElementById( location.hash.substring( 1 ) );
	
			if ( element ) {
				if ( ! /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) {
					element.tabIndex = -1;
				}
	
				element.focus();
	
				// Repositions the window on jump-to-anchor to account for header height.
				window.scrollBy( 0, -80 );
			}
		} );


		//! –– RESPONSIVE JQUERY
		
		/* get viewport width */
		responsive_viewport = $(window).width();
		
		if (responsive_viewport >= 768) {
			/* load gravatars */
			$('.comment img[data-gravatar]').each(function(){
				$(this).attr('src',$(this).attr('data-gravatar'));
			});
		} // if >= 768
		
		// Load up Foundation
		$(document).foundation();

		$('.testimonial-slider').each( function () {
			$(this).slick({
				autoplay: true,
				autoplaySpeed: 6000,
				arrows: false,
			});
		});

		if (responsive_viewport >= 1024) {
			/* on large, we equalize the height of the testimonial containers,
			   and the thumbnail. (everything with the equalizer class) */
			maxHeightEqualizer(".promo-height-equalizer");
		} else {
			/* on medium down, when things stack, we only equalize the 
			   testimonials. */
			maxHeightEqualizer(".promo-height-equalizer:not(.thumbnail)");
		}
		
	}); // jQuery document ready
	
	
	//! – ALL ASSETS LOADED
	
	/*
	   $(window).on('load', function () {

	   });
	 */
	
})(jQuery);

//! – FUNCTIONS

/**
 * Max Height Equalizer
 * 
 * Given a selector, give all elements matching that selector the same 
 * height as the tallest element.
 * 
 * @param      String selector a CSS selector string.
 * @return     null
 */
function maxHeightEqualizer(selector) {
	var height = 0;
	var elements = document.querySelectorAll(selector);

	for (var i = 0; i < elements.length; i++) {
		height = Math.max(height, elements[i].offsetHeight);
	}

	for (var i = 0; i < elements.length; i++) {
		elements[i].style.height = height + "px";
	}
}

/**
 * onYouTubePlayerAPIReady
 * 
 * Called when the YouTube Player API finished loading. 
 * When the document is ready, Set up youtube modals.
 * 
 * @return     null
 */
function onYouTubePlayerAPIReady() {
	$( document ).ready( function () {
		// Set up youtube modals
		$('.modaal-youtube-trigger').each( function () {
			
			/* The trigger element should have a data-video-element-id *
			   attribute containing the youtube video ID, which is also the ID
			   of the iframe DOM element. 
			 */
			var youtubeID = this.dataset.youtubeId;

			/* For each trigger, initialize modaal for that trigger. Add a
			   function to the after_open hook that initializes a YouTube Player
			   object and plays the video. */
			
			$(this).modaal({
				custom_class: "youtube",
				after_open: function () {
					loadYoutubeVideo(youtubeID);
				},
			});
		});
	});
}

/**
 * Load YouTube Video
 * 
 * @param      string elementID the ID of the youtube video == the ID of the 
 *                              iframe
 * @return     null
 */
function loadYoutubeVideo(youtubeID) {
	var player = new YT.Player("iframe-" + youtubeID, {
		height: '100%',
		width: '100%',
		videoId: youtubeID,
		playerVars: {rel: 0},
		events: {
			'onReady': function (event) {
				/* some mobile browsers won't var you auto play. 1024 should put
				 * us over the iPad Pro's viewport, at the expense of losing 
				 * autoplay for all the 1024x768 desktop users.
				 */
				if (responsive_viewport > 1024) event.target.playVideo();
			},
		},
	});
}

/**
 * Load YouTube Player API
 * https://developers.google.com/youtube/iframe_api_reference
 * 
 * @return     null
 */
function loadYouTubePlayerAPI() {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/player_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

/**
 * Event listeners for full bleed video
 */
function fullBleedVideo() {(function($) {
	$(document).on('ready', function() {
		const $fullBleedVideo = $( '.full-bleed-video' );
		if( !$fullBleedVideo.length ) return;
		
		$fullBleedVideo.on('click', function(e) {
			var video = $(this).find( 'video' ).get(0);
			if (video.paused) {
				video.play(); 
			} else {
				video.pause();
			}
		});
	});
})(jQuery)}

/**
 * Full Bleed Promo.
 */
function fullBleedPromo() {(function($) {
	var fullBleedPromo     = '.full-bleed-promo';
	var promoImg           = '> img';
	var bleedPromoImg      = fullBleedPromo + ` ${promoImg}`;
	var $fullBleedPromo    = $(fullBleedPromo);
    
	function scalePromos() {
	    $fullBleedPromo.each(function() {
		var $image          = $(this).find(promoImg);
		scaleImageContainer($(this), $image);
	    });
	}
    
	function parallaxPromos() {
	    $fullBleedPromo.each(function() {
		var $image = $(this).find(promoImg);
		if( !$image.hasClass('is-parallax') ) return;
		var containerView = elementInView($(this));
		if( containerView === 'view' ) {
		    parallaxImageContainer($(this), $image);
		}
	    });
	}
    
	$(document).on('ready', function() {
		scalePromos();
	});
    
	$(window).on('load', function() {
	    scalePromos();
	    parallaxPromos();
	});
    
	$(window).on('resize', function() {
	    scalePromos();
	});
    
	$(window).on('scroll', function() {
	    parallaxPromos();
	})
    
})(jQuery);}